export default __webpack_public_path__ + "static/media/blue-loader.114872da.svg";